// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gt","h5Button":"gt","button":"gu","block":"gv","btnDefault":"gw","disable":"gx","btnPrimary":"gy"};